import "./index.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { apiBaseUrl, authority, clientId } from "./config";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider, Container, Flex } from "@chakra-ui/react";
import Fonts from "./theme/fonts";
import { AppHeader } from "./compositions/AppHeader";
import { theme } from "./theme/theme";
import { client } from "./clients/BackOfficeApi/client.gen";
import { MsalProvider } from "@azure/msal-react";
import {
  Configuration as PublicClientApplicationConfiguration,
  PublicClientApplication,
} from "@azure/msal-browser";
import { I18n } from "./components/I18n";
import { DirtyContextProvider } from "./contexts/DirtyContext";

const root = ReactDOM.createRoot(document.getElementById("root")!);

document.body.style.overflow = "hidden";

client.setConfig({
  baseUrl: apiBaseUrl,
});

const configuration: PublicClientApplicationConfiguration = {
  auth: {
    authority,
    clientId,
    redirectUri: window.location.origin,
  },
};

const pca = new PublicClientApplication(configuration);

root.render(
  <React.StrictMode>
    <MsalProvider instance={pca}>
      <BrowserRouter>
        <ChakraProvider resetCSS theme={theme}>
          <DirtyContextProvider>
            <Fonts />
            <Container
              as={Flex}
              direction="column"
              h="100dvh"
              m={0}
              maxH="100vh"
              maxW="100vw"
              overflow="hidden"
              p={0}
              w="full"
            >
              <I18n locale="nl">
                <AppHeader />
                <App />
              </I18n>
            </Container>
          </DirtyContextProvider>
        </ChakraProvider>
      </BrowserRouter>
    </MsalProvider>
  </React.StrictMode>,
);
